<template>
    <div v-if="!loading && list" class="w-full flex flex-column gap-3 max-w-30rem">
        <MobMenu v-if="list.length>0" :items="[]" :footerTxt="content[lang_].footer">
            <template v-slot:body>
                <div v-for="item of list" @click="showItem(item)"
                    class="w-full relative flex flex-row gap-2 px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:65px">
                    <div class="flex flex-row flex-1 gap-2">
                        <div class="flex">
                            <AvatarGroup>
                                <Avatar :image="getBankImage(item.bank_code)" class="w-full surface-0" shape="circle"/>
                            </AvatarGroup>
                        </div>
                        <div class="flex-1 flex flex-column gap-2 justify-content-center">
                            <div class="w-full flex flex-row gap-1 overflow-hidden white-space-nowrap">
                                <span v-if="item.fields && item.fields.fullname" 
                                    class="flex font-medium text-sm xl:text-md">
                                    {{ item.fields.fullname }}
                                </span>
                                <i class="pi pi-verified text-600 text-primary text-xs"></i>
                            </div>
                            <div class="w-full flex flex-row gap-1 overflow-hidden font-base text-500 text-sm xl:text-md white-space-nowrap">
                                <span class="flex">
                                    {{ getBankTitle(item.bank_code) }}
                                </span>
                                <div v-if="item.fields && (item.fields.account_number || item.fields.card_number || item.fields.phone_number || item.fields.telegram || item.fields.wallet_address)"
                                    class="flex">
                                    <span v-if="item.fields.account_number">{{ item.fields.account_number }}</span>
                                    <span v-else-if="item.fields.card_number">{{ formatCardNumber(item.fields.card_number) }}</span>
                                    <span v-else-if="item.fields.phone_number">{{ item.fields.phone_number }}</span>
                                    <span v-else-if="item.fields.telegram">Tg: {{ item.fields.telegram }}</span>
                                    <span v-else-if="item.fields.wallet_address">{{ getShort(item.fields.wallet_address, 30) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-content-right align-items-center cursor-pointer" >
                        <i class="text-blue-500 ml-2" :class="'pi pi-angle-right'" />
                    </div>
                </div>
            </template>
        </MobMenu>  
        <div v-if="list.length>0" class="flex w-full align-items-center justify-content-center surface-0 border-round-2xl">
            <Paginator v-if="total && total>rows" 
                :rows="rows" :first="skip" :totalRecords="total" :rowsPerPageOptions="[10, 20, 30]" @update:first="onChangePage" 
                template="PrevPageLink PageLinks NextPageLink" class="flex"/>
        </div>
        <div v-else class="w-full flex flex-column p-3 surface-0 border-round-xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl">
            <span class="text-900 text-sm text-center">
                {{ content[lang_].empty }}
            </span>
        </div>
    </div>
    <Dialog v-if="selectedItem" v-model:visible="itemPopup" modal
        class="w-full border-round-xl overflow-hidden border-none surface-100 mx-2"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang_].detailTitle }}</span>
        </template>

        <div class="flex flex-column gap-2">
            <div class="flex flex-column gap-2">
                <span v-if="selectedItem.currency_code" class="flex">
                    <span class="text-600">{{ content[lang_].currency }}</span>
                    <span class="ml-2 uppercase">{{ selectedItem.currency_code }}</span>
                </span>
                <span v-if="selectedItem.bank_code" class="flex">
                    <span class="text-600">{{ content[lang_].bank }}</span>
                    <span class="ml-2">{{ getBankTitle(selectedItem.bank_code) }}</span>
                </span>
                <span v-if="selectedItem.date_created" class="flex">
                    <span class="text-600">{{ content[lang_].createdAt }}</span>
                    <span class="ml-2">{{ formatDate(selectedItem.date_created) }}</span>
                </span>
            </div>
            <div v-if="selectedItem.fields" class="flex flex-column gap-2">
                <span v-if="selectedItem.fields.fullname" class="flex">
                    <span class="text-600">{{ content[lang_].recipient }}</span>
                    <span class="ml-2">{{ selectedItem.fields.fullname }}</span>
                    <span @click="copy(selectedItem.fields.fullname)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
                <span v-if="selectedItem.fields.account_number" class="flex">
                    <span class="text-600">{{ content[lang_].accountNumber }}</span>
                    <span class="ml-2">{{ selectedItem.fields.account_number }}</span>
                    <span @click="copy(selectedItem.fields.account_number)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
                <span v-if="selectedItem.fields.card_number" class="flex">
                    <span class="text-600">{{ content[lang_].cardNumber }}</span>
                    <span class="ml-2">{{ selectedItem.fields.card_number }}</span>
                    <span @click="copy(selectedItem.fields.card_number)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
                <span v-if="selectedItem.fields.wallet_address" class="flex">
                    <span class="text-600">{{ content[lang_].walletAddress }}</span>
                    <span class="ml-2">{{ selectedItem.fields.wallet_address }}</span>
                    <span @click="copy(selectedItem.fields.wallet_address)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
                <span v-if="selectedItem.fields.wallet_network" class="flex">
                    <span class="text-600">{{ content[lang_].walletNetwork }}</span>
                    <span class="ml-2">{{ selectedItem.fields.wallet_network }}</span>
                </span>
                <span v-if="selectedItem.fields.telegram" class="flex">
                    <span class="text-600">{{ content[lang_].telegram }}</span>
                    <a :href="'https://t.me/'+selectedItem.fields.telegram" target="_blank" class="cursor-pointer text-primary ml-2">
                        {{ selectedItem.fields.telegram }}
                    </a>
                    <span @click="copy(selectedItem.fields.telegram)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
                <span v-if="selectedItem.fields.bank_name" class="flex">
                    <span class="text-600">{{ content[lang_].bank }}</span>
                    <span class="ml-2">{{ selectedItem.fields.bank_name }}</span>
                </span>
                <span v-if="selectedItem.fields.address" class="flex">
                    <span class="text-600">{{ content[lang_].address }}</span>
                    <span class="ml-2">{{ selectedItem.fields.address }}</span>
                </span>
                <span v-if="selectedItem.fields.city" class="flex">
                    <span class="text-600">{{ content[lang_].city }}</span>
                    <span class="ml-2">{{ selectedItem.fields.city }}</span>
                </span>
                <span v-if="selectedItem.fields.country" class="flex">
                    <span class="text-600">{{ content[lang_].country }}</span>
                    <span class="ml-2">{{ selectedItem.fields.country }}</span>
                </span>
                <span v-if="selectedItem.fields.swift_code" class="flex">
                    <span class="text-600">{{ content[lang_].swift }}</span>
                    <span class="ml-2">{{ selectedItem.fields.swift_code }}</span>
                    <span @click="copy(selectedItem.fields.swift_code)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
                <span v-if="selectedItem.fields.iban_number" class="flex">
                    <span class="text-600">{{ content[lang_].iban }}</span>
                    <span class="ml-2">{{ selectedItem.fields.iban_number }}</span>
                    <span @click="copy(selectedItem.fields.iban_number)" class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
            </div>
        </div>

        <template #footer>
            <Button :label="content[lang_].detailBtnClose" icon="pi pi-times" @click="itemPopup = false" class="w-full surface-0 border-round-xl" size="large" severity="secondary" />
        </template>
    </Dialog>
</template>

<script>
import Connect from         '@/assets/js/Connect.js'
import Helper from          '@/assets/js/Helper.js'
import MobMenu from         '@/components/sides/menu/MobMenu.vue' 
import { PaymentSystemList, BankList, Bank } from '@/assets/js/classes/PaymentSystem.js'

export default {
    props: {
        list: { 
            type: Array, 
            default: () => [] 
        },
        total: { 
            type: Number, 
            default: 0 
        },
        rows: { 
            type: Number, 
            default: 10 
        },
        skip: { 
            type: Number, 
            default: 0 
        },
        loading: { 
            type: Boolean, 
            default: true 
        }
    },
    data() {
        return {
            content: {
                en: { 
                    empty: 'No recipients',
                    trans: 'recipients',
                    from: 'from',
                    copy: 'Copied',
                    footer: 'Recipient details can only be changed through the administrator',
                    detailTitle: 'Recipient',
                    currency: 'Currency:',
                    bank: 'Bank:',
                    createdAt: 'Created at:',
                    recipient: 'Recipient:',
                    accountNumber: 'Account number:',
                    cardNumber: 'Card number:',
                    walletAddress: 'Wallet address:',
                    walletNetwork: 'Wallet network:',
                    telegram: 'Telegram:',
                    address: 'Address:',
                    city: 'City:',
                    country: 'Country:',
                    swift: 'SWIFT:',
                    iban: 'IBAN:',
                    detailBtnClose: 'Close'
                },
                ru: { 
                    empty: 'Нет получателей',
                    trans: 'получателей',
                    from: 'из',
                    copy: 'Скопировано',
                    footer: 'Реквизиты получателя можно изменить только через администратора',
                    detailTitle: 'Получатель',
                    currency: 'Валюта:',
                    bank: 'Банк:',
                    createdAt: 'Дата создания:',
                    recipient: 'Получатель:',
                    accountNumber: 'Номер аккаунта:',
                    cardNumber: 'Номер карты:',
                    walletAddress: 'Адрес кошелька:',
                    walletNetwork: 'Сеть кошелька:',
                    telegram: 'Telegram:',
                    address: 'Адрес:',
                    city: 'Город:',
                    country: 'Страна:',
                    swift: 'SWIFT:',
                    iban: 'IBAN:',
                    detailBtnClose: 'Закрыть'
                }
            },
            selectedItem: null,
            itemPopup: false,
            bankList: []
        }
    },
    components: {
        MobMenu
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    methods: {
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copy, detail: text, life: 1000 })
        },
        formatCardNumber(val){
            return this.helper.format_card(val)
        },
        formatDate(value) {
            return this.helper.format_date_short(value)
        },
        showItem(item){
            this.selectedItem = item
            this.itemPopup = true
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.bankList
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bankList
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : code
        },
        getShort(value){
            if(!value) return ''
            return this.helper.get_short_name(value, 70)
        },
        getFormatDate(date) {
            return this.helper.format_date_short(date)
        },
        onChangePage(event) {
            this.$emit('update:first', event)
        },
        onChangeRows(event) {
            this.$emit('update:rows', event)
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.bankList = await BankList.GetList(this.$store).then(res => res)
    },
}
</script>